// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc164f21","311":"4a4909a9","453":"cde9bea2","732":"6d6918aa","857":"6ab8905f","977":"15b077a9"}[chunkId] + ".chunk.js";
};